// Copyright (c) 2017 Deere & Company

import AdvancedClaimSummaryReport from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reports.advancedClaimSummary,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedLayout: state.reportVariant.selectedLayout,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {location} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName: location.pathname
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AdvancedClaimSummaryReport);



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state-connector.js